import { VariantFilter } from "@/models/VariantFilter";
import { Translations } from "@/utils/Translations";
import { Config } from "@/settings/Config";
import { ValidityHelper } from "@/utils/ValidityHelper";
import {ValidityDomains, ValidityDomainValues} from "@/settings/ValidityDomains";

export class TopicHelper {
  public static applyContentValidity(
    $content: JQuery,
    activeFilters: VariantFilter<string | string[]>[],
    config: Config,
    validityHelper: ValidityHelper
  ) {
    if ($content.length === 0) {
      return;
    }

    // Loop through all validity selectors
    $content.find(".validity").each((index: number, element: HTMLElement) => {
      const $element = $(element);
      //
      // Create a validity object
      //
      const validities: Partial<{ [K in ValidityDomainValues]: string[] }> = {};
      Object.entries(ValidityDomains).forEach(([key, value]) => {
        const domain: ValidityDomainValues = value;
        if ($element.data(domain)) {
          validities[domain] = $element.data(domain).toString().split("|");
        }
      });

      //
      // We can now use the validity object with the matchValidity method!
      //
      if (!validityHelper.matchValidity(activeFilters, validities)) {
        $element.attr("area-hidden", "true").addClass("filtered-out");
      }
    });

    //
    //  Set empty classes on subsegments that only contains filtered-out validity sections
    //
    $content.find(".subsegment").each(function () {
      let filteredOut = true;
      $(this)
        .find("> *")
        .each(function () {
          if (!$(this).hasClass("filtered-out")) {
            filteredOut = false;
          }
        });
      if (filteredOut) {
        $(this).addClass("empty");
      }
    });
  }

  public static highlightNews(structureWeekFilter: VariantFilter<string>) {
    $("[data-news]").each((i, e) => {
      const $e = $(e);
      const news = $e.data("news");

      if (news.indexOf(structureWeekFilter.entry) > -1) {
        $e.addClass("news");
      }
    });
  }

  public static addGearboxHighlight(gearboxFilter: VariantFilter<string[]>, t: Translations) {
    $(".topic-article > .article-ref").each((i, e) => {
      const topicArticle = $(e);
      const topicGearboxes = topicArticle.data("gearbox");

      let topicGearboxList: string[] = [];

      if (topicGearboxes && topicGearboxes.length > 0) {
        topicGearboxList = this.highlightGearbox(topicArticle, gearboxFilter);
        const validGearboxes = topicGearboxList.join(", ");

        const articleContent = $(".article-content", topicArticle);

        $(
          `<span class="gearbox-title gearbox-title--topic"><strong>${t.FilterGearboxValidForTopic}</strong> ${validGearboxes}</span>`
        ).insertBefore(articleContent);
      }

      $("[data-gearbox]", topicArticle).each((i, e) => {
        const $e = $(e);

        const validGearboxList = this.highlightGearbox($e, gearboxFilter);

        const matchTopicGearboxes = topicGearboxList.every((val) => {
          return validGearboxList.indexOf(val) >= 0;
        });
        // validGearboxList.forEach((x) => {
        //   let match = topicGearboxList.find(g => g === x)

        // })

        if (!matchTopicGearboxes) {
          $e.addClass("active-gearbox-filter");
          const validGearboxes = validGearboxList.join(", ");

          const segment = $(".segment", $e);
          const wrapper = segment.length > 0 ? segment : $e;
          wrapper.prepend(
            `<span class="gearbox-title"><strong>${t.FilterGearboxValidFor}</strong> ${validGearboxes}</span>`
          );
        }
      });
    });
  }

  public static highlightGearbox($e: JQuery, gearboxFilter: VariantFilter<string[]>): string[] {
    const gearBoxValidity = $e.data("gearbox").split("|");
    const validityGearbox = gearboxFilter.entry;
    const gearboxes: string[] = [];

    if ($e.data("gearbox").indexOf("!") > -1 && validityGearbox) {
      // If negated, show all currently available gearboxes except the negated one.
      for (let i = 0; i < validityGearbox.length; i++) {
        if (gearBoxValidity.indexOf(`!${validityGearbox[i]}`) === -1) {
          gearboxes.push(validityGearbox[i]);
        }
      }
    } else {
      // Show listed gearboxes that are available for current filters
      for (let i = 0; i < validityGearbox.length; i++) {
        if (gearBoxValidity.indexOf(`${validityGearbox[i]}`) >= 0) {
          gearboxes.push(validityGearbox[i]);
        }
      }
    }

    return gearboxes;
  }
}
